import { render, staticRenderFns } from "./CallDemoIcon.vue?vue&type=template&id=484b7b18&scoped=true&"
import script from "./CallDemoIcon.vue?vue&type=script&lang=js&"
export * from "./CallDemoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b7b18",
  null
  
)

export default component.exports